import React from 'react'

import Spinner from '../spinner/Spinner'

const PageLoader = () => <div className="page-loader"><Spinner /></div>

export default PageLoader;